// Customizable Area Start
import React, { Component } from "react";
import {
  Box,
  Typography,
  TextField,
  BaseTextFieldProps,
  styled,
  InputAdornment,
  IconButton,
  SxProps,
  Theme
} from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const FieldLabel = styled(Typography)({
  fontWeight: 400,
  fontSize: "0.875rem",
  lineHeight: "22px",
  color: "#0F172A",
  textAlign: "left",
  marginBottom: "4px",
});

const Field = styled(TextField)({
  overflow: "hidden",
  borderRadius: "28px",
  "& input": {
    color: "#0F172A",
    borderRadius: "28px",
    padding: "16.5px 20px",
  },
  "& fieldset": {
    borderRadius: "28px",
    border: "1px solid #CBD5E1",
  },
  "& .MuiInputAdornment-root .MuiSvgIcon-root": {
    fill: "#94A3B8",
  },
});

interface IProps extends Omit<BaseTextFieldProps, "error"> {
  label: string;
  error?: string;
  touched?: boolean;
  wrapperSx?: SxProps<Theme>
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface IState {
  showPassword: boolean;
}

export class CustomTextField extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  render() {
    const { label, touched, error, type, wrapperSx = {}, handleChange, ...rest } = this.props;
    const { showPassword } = this.state;
    const isError = Boolean(error) && touched;

    return (
      <Box sx={{...wrapperSx}}>
        <FieldLabel>{label}</FieldLabel>
        <Field
          test-data-id="input-field"
          onChange={handleChange}
          error={isError}
          helperText={isError ? error : ""}
          type={type === "password" && !showPassword ? "password" : "text"}
          InputProps={
            type === "password"
              ? {
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        onClick={this.togglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOutlinedIcon sx={{ fill: "#94A3B8" }} />
                        ) : (
                          <VisibilityOffOutlinedIcon sx={{ fill: "#94A3B8" }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              : {}
          }
          {...rest}
        />
      </Box>
    );
  }
}

export default CustomTextField;
// Customizable Area End
